import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import Loader from '../../../loader/Loader'
import Text from '../../../input_filed/Text'
import SelectStatus from '../../../input_filed/SelectStatus'
import SaveButton from '../../../buttons/SaveButton'
import { ToastContainer, toast } from 'react-toastify'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { BrandSchema } from './Validation'
import { UpdateBrandRes, UpdateBrandTodo } from '../../../../redux/slices/master_slice/vehical_brand/UpdateBrand'

export default function UpdateBrandForm() {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { state } = useLocation()
    const id = state?.id

    const initialValues = {
        brand: state?.vehicle_brand_name,
        status: state?.vehicle_brand_status
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: BrandSchema,

        onSubmit: (values, action) => {
            setLoading(true)
            dispatch(UpdateBrandTodo({ values,id })).then(() => update_res(action))
        }
    })

    const update_res = () => {
        if (UpdateBrandRes?.success) {
            toast.success(UpdateBrandRes?.message, { position: "bottom-right" });
            setLoading(false)
            setTimeout(() => {
                navigate('/brand')
            }, 1500);
        } else {
            setLoading(false)
            toast.error(UpdateBrandRes?.message, { position: "bottom-right" });
        }
    }

    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                <div className='form_layout mt-3'>
                    {loading ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :
                        <div className='row'>
                            <div className='col-md-4'>
                                <Text
                                    label_name='Brand'
                                    placeholder=''
                                    name='brand'
                                    value={values.brand || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.brand && touched.brand ? (<span className='text-danger form_label' >{errors.brand}</span>) : null}
                                />
                            </div>

                            <div className='col-md-4'>
                                <SelectStatus
                                    closeMenu={true}
                                    label_name='Status'
                                    disabled={false}
                                    name='status'
                                    defaultValue={values.status}
                                    onChange={(e) =>
                                        setFieldValue('status', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null}
                                />
                            </div>
                            <div className='col-md-12 text-end mt-2'>
                                <SaveButton name={'Update'} />
                            </div>
                        </div>}
                </div>
            </Form>
            <ToastContainer/>
        </>
    )
}
